import { computed, makeObservable } from 'mobx'

import hasFeature from 'modules/core/lib/hasFeature'
import { Model } from 'modules/core/lib/mobx-rest'

import { TYPES } from './AttendanceSetting'

interface IBalanceCarryover {
  [key: string]: number | boolean | string | null
}

export const RESET_FREQUENCIES = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  NEVER: 'never',
  CUSTOM_PERIOD: 'custom_period', // Remove when removing the FF dev_time_tracking_weekly_balance_compensation
}

export const getResetFrecuencies = () => {
  const hasWeeklyBalanceCompensation = hasFeature('dev_time_tracking_weekly_balance_compensation')

  const fieldToRemove = hasWeeklyBalanceCompensation
    ? RESET_FREQUENCIES.CUSTOM_PERIOD
    : RESET_FREQUENCIES.WEEKLY

  return Object.values(RESET_FREQUENCIES).filter(
    (resetFrequency) => resetFrequency !== fieldToRemove
  )
}

class BalanceCarryover extends Model<IBalanceCarryover> {
  constructor(attr: IBalanceCarryover) {
    super(attr)
    makeObservable(this, {
      type: computed,
    })
  }

  static urlRoot() {
    return '/api/rest/attendance/balance_carryover'
  }

  get type(): string {
    return TYPES.BALANCE_CARRYOVER
  }

  get resetFrequency(): string {
    const hasWeeklyBalanceCompensation = hasFeature('dev_time_tracking_weekly_balance_compensation')

    if (
      hasWeeklyBalanceCompensation &&
      this.attributes.reset_frequency === RESET_FREQUENCIES.CUSTOM_PERIOD
    ) {
      return RESET_FREQUENCIES.MONTHLY
    }

    // eslint-disable-next-line no-type-assertion/no-type-assertion
    return (this.attributes.reset_frequency ?? RESET_FREQUENCIES.MONTHLY) as string
  }

  get frequencyWeekly(): boolean {
    return this.resetFrequency === RESET_FREQUENCIES.WEEKLY
  }
}

export default BalanceCarryover
